export default "__VITE_ASSET__f5f99455__"